import type { FC } from 'react';
import { SvgIcon, type SvgIconName } from './svg-icon';
import styles from '../styles/clickable-icon.module.scss';

const ClickableIcon: FC<{
    iconName: SvgIconName;
    onClick: () => void;
}> = ({ iconName, onClick }) => {
    return (
        <div className={styles.clickableIcon} onClick={onClick}>
            <SvgIcon name={iconName} />
        </div>
    );
};

export default ClickableIcon;
